<template>
<div v-if="item">
    <LoadingApp
        :isLoading.sync="isLoading"
        :is_full_page="false"
    />
    <div style="margin-bottom: 0;" class="product-single-container product-single-default product-quick-view container">
        <div class="row">
            <template v-if="item">
                <product-width :key="keyProductImage" v-if="mediaDesktop" class="col-lg-6 col-md-6 product-single-gallery mb-2">
                    <div class="product-slider-container product-item">
                        <div class="product-single-carousel owl-carousel owl-theme product-single-carousel-quick-view">
                            <template v-for="imgs in item.images">
                                <div class="product-item"
                                    v-if="imgs.is_table_size==false"
                                    :key="imgs.id"
                                >
                                    <img
                                        class="product-single-image"
                                        :src="imgs.url"
                                        :data-zoom-image="imgs.url"
                                        loading="lazy"
                                        :style="`object-fit: contain; max-height: ${maxHeightImage}`"
                                    />
                                </div>
                            </template>
                        </div>
                    </div>
                    <div class="prod-thumbnail row owl-dots" id="carousel-custom-dots-modal">
                        <template v-for="img in item.images">
                            <div
                                class="col-3 owl-dot"
                                v-if="img.is_table_size==false"
                                :key="img.id"
                            >
                                <img
                                    :src="img.url"
                                    loading="lazy"
                                    :style="'object-fit: contain; '+(maxHeightImage == 'none' ? '' : `max-height: calc(${maxHeightImage} / 4)`)"
                                />
                            </div>
                        </template>
                    </div>
                </product-width>

                <product-width v-else :key="keyProductImage" class="col-lg-6 col-md-6 mb-2">
                    {{initCarouselBootstrap(item)}}
                    <div
                        id="carouselModalProductsBootstrap"
                        class="carousel slide"
                        data-ride="carousel"
                        style="width: 100%; margin-top: 10px;"
                        data-interval="10000"
                    >
                        <div class="carousel-inner">
                            <template v-for="(img, key) in item.images">
                                <div  v-if="img.url == item.image_main" class="carousel-item active" :key="key" :id="'carousel-item-'+img.id">
                                    <img class="d-block w-100" :src="item.image_main" loading="lazy" :style="`object-fit: contain; max-height: ${maxHeightImage}`">
                                </div>
                                <div v-if="img.url != item.image_main && img.is_table_size==false" :key="key" class="carousel-item" :id="'carousel-item-'+img.id">
                                    <img class="d-block w-100" :src="img.url" loading="lazy" :style="`object-fit: contain; max-height: ${maxHeightImage}`">
                                </div>
                            </template>
                        </div>
                        <template v-if="hasControlsCarousel">
                            <a class="carousel-control-prev" href="#carouselModalProductsBootstrap" role="button" data-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span class="sr-only">Anterior</span>
                            </a>
                            <a class="carousel-control-next" href="#carouselModalProductsBootstrap" role="button" data-slide="next">
                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                <span class="sr-only">Próximo</span>
                            </a>
                        </template>
                    </div>
                    <ol class="carousel-indicators row"
                        style="position: relative; bottom: 0;
                            justify-content: start;
                            margin: 10px 0px 0px 0px;
                            width: 100%;"
                    >
                        <template v-for="(i) in item.images">
                            <li data-target="#carouselModalProductsBootstrap"
                                style="width:80px; height:auto; margin: 0px 10px 10px 0;"
                                class="active"
                                @click="controlsIndicatorsSlider(i.id)"
                                :key="i.id"
                                v-if="i.url == item.image_main"
                            >
                                <img
                                    :src="item.image_main"
                                    alt=""
                                    loading="lazy"
                                    :style="'object-fit: contain; '+(maxHeightImage == 'none' ? '' : `max-height: calc(${maxHeightImage} / 4)`)"
                                >
                            </li>
                            <li :key="i.id"
                                v-if="i.url != item.image_main && i.is_table_size==false"
                                data-target="#carouselModalProductsBootstrap"
                                style="width:80px; height:auto; margin: 0px 10px 10px 0;"
                                @click="controlsIndicatorsSlider(i.id)"
                            >
                                <img
                                    :src="i.url"
                                    alt=""
                                    loading="lazy"
                                    :style="'object-fit: contain; '+(maxHeightImage == 'none' ? '' : `max-height: calc(${maxHeightImage} / 4)`)"
                                >
                            </li>
                        </template>
                    </ol>
                </product-width>
            </template>

            <div class="col-lg-6 col-md-12">
                <div class="product-single-details" :style="'font-family:'+$root.$children[0].theme.font_family">
                    <product-title v-if="item">
                        <template v-if="showCodeOriginal">{{ item.api_cod_original }} - </template>
                        {{ product_name_site }}
                    </product-title>

                    <Rating
                        v-if="item && showRatings"
                        :item.sync="item"
                        :showTotalReviews="true"
                    />
                    <br/>
                    <!-- <template v-if="hidePrice == false">
                        <div
                            v-if="item && !item.price_on_request && (((item.pro_stock_site > 0 || item.sell_out_of_stock == true)&& company.finalizacao_pagamento.tipo == 'PAGAMENTO') || (company.finalizacao_pagamento.mostrar_preco && company.finalizacao_pagamento.tipo == 'ORCAMENTO'))"
                            class="price-box"
                        >
                            <template v-if="!getFlavorsSelected.length">
                                <span v-if="variations.length && item.is_linked_products == false && !validateProductGroup"
                                    :style="'font-size: 16px; font-weight: 600; color: #999;'">
                                    A partir de
                                </span>
                                <span v-if="item.price_to ||( item.from_price_site && item.pro_price_site && item.pro_price_site > item.from_price_site ) " class="old-price">
                                    {{currency.money(item.pro_price_site || item.from_price_site)}}
                                </span>
                                <product-price-page class="product-price">
                                    {{ !item.price_to ? currency.money(item.from_price_site || item.pro_price_site) : currency.money(item.price_to) }}
                                </product-price-page>
                            </template>
                            <template v-else>
                                <span v-if="item.price_to" class="old-price">
                                    {{ currency.money(Math.max(...getFlavorsSelected.map(flavor => flavor.price), item.pro_price_site)) }}
                                </span>
                                <product-price-page class="product-price">
                                    {{ currency.money(Math.max(...getFlavorsSelected.map(flavor => getPriceFlavor(flavor.price)), item.price_to ? item.price_to : item.pro_price_site)) }}
                                </product-price-page>
                            </template>

                            <product-price-page class="product-price" v-if="getShowUnitOfMeasureInProductPrice">
                                <small style="font-size: 1.3rem; font-weight: 500;">{{ item.pro_sigla_medida }} ({{ item.med_desc }})</small>
                            </product-price-page>

                            <product-price-page class="product-price" v-if="additionalItemsSelected && additionalItemsSelected.items && additionalItemsSelected.items.length">
                                +
                            </product-price-page>

                            <div style="margin-top: 0.5rem" v-if="additionalItemsSelected && additionalItemsSelected.items && additionalItemsSelected.items.length">
                                <c-span
                                    v-for="(additionalItem, key) in additionalItemsSelected.items"
                                    :key="key" class="additional-item-price-box"
                                    style="font-weight: 500"
                                >
                                    {{ additionalItem.abbreviation }} - {{ currency.money(additionalItem.price) }}
                                </c-span>
                            </div>

                            <template v-if="showIpi">
                                <c-span v-if="ipi_variation"><br>+ IPI</c-span>
                                <c-span v-if="item.ipi_percentage"><br>+ {{ item.ipi_percentage }}% de IPI</c-span>
                            </template>

                            <div>
                                <InterestFreeInstallments
                                    :item="item"
                                    :product_modal="true"
                                />
                            </div>
                        </div>
                    </template> -->

                    <ProductPrice v-if="!hidePrice" :product="item" />

                    <template v-else>
                        <c-span style="font-size: 1.5rem; display: inline-block; margin: 0.5rem 0">
                            Faça login para ter acesso às ações de {{ isBudgetLayout ? 'orçamento' : 'compra' }} e aos preços, clicando no botão abaixo.
                        </c-span><br>
                        <c-ancora
                            :backgroundColor="$root.$children[0].theme.products.button.background_color"
                            :backgroundColorHover="$root.$children[0].theme.products.button.background_color_hover"
                            :color="$root.$children[0].theme.products.button.color"
                            :colorHover="$root.$children[0].theme.products.button.color_hover"
                            :borderColor="$root.$children[0].theme.products.button.border_color"
                            :borderColorHover="$root.$children[0].theme.products.button.border_color_hover"
                            :borderRadius="$root.$children[0].theme.products.button.border_radius"
                            :href="$baseUrl+'login'"
                            padding="0.85rem 2.5rem"
                            class="mt-1 mb-2"
                            title="Entrar"
                        >
                            <span :style="'text-transform:'+$root.$children[0].theme.products.button.text_transform+'; font-size:'+$root.$children[0].theme.font_size_button">
                                Entrar
                            </span>
                        </c-ancora>
                    </template>

                    <template v-if="show_payment_flags_product_page == true">
                        <ul v-if="payment_flags.length > 0" class="d-flex align-items-center row" style="margin: 2.8rem 0 2.4rem;">
                            <li v-for="flag in payment_flags"
                                :key="flag.id"
                                class="mr-3 mb-2"
                            >
                                <img style="max-width: 35px;" :src="flag.image" loading="lazy">
                            </li>
                        </ul>
                       <img v-if="payment_flags.length < 1" :src="$baseUrl+'assets/images/payments.png'" style="max-width: 200px; margin: 2.8rem 0 2.4rem;" loading="lazy">
                    </template>

                    <div
                        v-if="item"
                        class="product-desc"
                    >
                        <p v-if="item.pro_desc_min" v-html="item.pro_desc_min" style="line-height: 20px; margin-bottom: 0;"></p>

                    </div>
                    <template v-if="locale_linked_products == 2">
                        <ProductSideVariations
                            :v.sync="$v"
                            @selectedVariation="selectedVariation"
                        />
                    </template>

                    <ProductOptionsConversionUnity
                        :item.sync="item"
                    />

                    <ProductItemsGrid
                        v-if="showItemsGrid"
                        :validate.sync="$v"
                        :item_grid.sync="item_grid"
                        local="modal"
                        @handleSelectItemGrid="handleSelectItemGrid"
                    />

                    <ProductFractionalSale v-if="item.fractional_sale" />

                    <template v-if="variations.length == 0 || locale_linked_products == 2">
                        <ProductActions
                            :item.sync="item"
                            :isProductCustomization="isProductCustomization"
                            :activateProductCustomization="activateProductCustomization"
                            @addCart="addCart"
                            @showModalProductCustomization="showModalProductCustomization"
                        />
                    </template>
                    <div v-if="company.finalizacao_pagamento.tipo == 'PAGAMENTO' && item.free_shipping" class="">
                        <ul>
                            <li style="display:flex; align-items:center">
                                <i class="icon-shipping" style="color:#202020; font-size:4rem"></i>
                                <strong
                                    style="text-transform: uppercase;"
                                >
                                    <c-span>FRETE GRÁTIS</c-span>
                                </strong>
                            </li>
                        </ul>
                    </div>
                    <CalculaFrete
                        v-if="item && (variations.length == 0 || locale_linked_products == 2) && !item.free_shipping && !item.price_on_request"
                        :product_id.sync="item.id"

                    />
                     <LinkYoutube :item.sync="item" />
                </div>
                <div v-if="item.image_stamp.url_stamp" class="image_stamp">
                       <img :src="item.image_stamp.url_stamp" alt="">
                    </div>

            </div>
        </div>

        <!-- SABORES -->
        <ProductFlavors
            @addCart="addCart"
        />

        <!-- VARIAÇÕES -->
        <ProductVariations
            v-if="variations.length > 0 && locale_linked_products == 1"
            :item="item"
            :linked_products="variations"
            :locale_linked_products="locale_linked_products"
            local="modal"
        />

        <!-- IMAGEM DA TABELA DE TAMANHOS -->
        <div v-if="item && item.images.findIndex(el=>el.is_table_size===true) > -1" class="row mt-1 mb-2">
            <div class="col-12 row">
                <template v-for="img in item.images">
                    <div class="mt-2 col-12 col-lg-6" v-if="img.is_table_size==true && img.side == 'LEFT'" :key="img.id">
                        <a data-toggle="modal" :data-target="'#modal-table-modal-size-'+img.id">
                            <img style="width:100%; cursor:pointer;" :src="img.url" loading="lazy">
                        </a>

                        <div class="modal fade" :id="'modal-table-modal-size-'+img.id" :aria-labelledby="'modal-table-modal-size-'+img.id" aria-hidden="true">
                            <div class="modal-dialog" style="max-width: auto;">
                                <modal-content class="modal-content" :id="'content-modal-table-modal-size-'+img.id">
                                    <div class="modal-header" style="height:30px; border: none;">
                                        <button type="button" class="close" @click.prevent="$root.closeModalApp('modal-table-modal-size-'+img.id)">&times;</button>
                                    </div>
                                    <div class="modal-body d-flex align-items-center justify-content-center" style="padding: 0; max-height: 100%;">
                                        <img :src="img.url" loading="lazy">
                                    </div>
                                </modal-content>
                            </div>
                        </div>
                    </div>
                    <div class="mt-2 col-12 col-lg-6" v-if="img.is_table_size==true && img.side == 'RIGHT'" :key="img.id">
                        <a data-toggle="modal" :data-target="'#modal-table-modal-size-'+img.id">
                            <img style="width:100%; cursor:pointer;" :src="img.url" loading="lazy">
                        </a>

                        <div class="modal fade" :id="'modal-table-modal-size-'+img.id" :aria-labelledby="'modal-table-modal-size-'+img.id" aria-hidden="true">
                            <div class="modal-dialog" style="max-width: auto;">
                                <modal-content class="modal-content" :id="'content-modal-table-modal-size-'+img.id">
                                    <div class="modal-header" style="height:30px; border: none;">
                                        <button type="button" class="close" @click.prevent="$root.closeModalApp('modal-table-modal-size-'+img.id)">&times;</button>
                                    </div>
                                    <div class="modal-body d-flex align-items-center justify-content-center" style="padding: 0; max-height: 100%;">
                                        <img :src="img.url" loading="lazy">
                                    </div>
                                </modal-content>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import ProductActions from './ProductActions'
import Currency from '../../helpers/parseCurrency'
import { mapState, mapActions, mapGetters } from 'vuex'
import {requiredIf} from 'vuelidate/lib/validators'
import LoadingApp from '../LoadingApp'
import CalculaFrete from './CalculaFrete.vue'
import LinkYoutube from './LinkYoutube.vue'
import InterestFreeInstallments from './InterestFreeInstallments.vue'
import Rating from './Rating.vue'
import {CAncora} from '../Styles/Button/styled'
import { CProductPricePage, CProductTitle, CProductWidth } from '../Styles/Product/styled'
import { CModalContent } from '../Styles/Template/styled'
import { CSpan } from '../Styles/Components/styled'
import ProductVariations from './ProductVariations.vue'
import ProductOptionsConversionUnity from './ProductOptionsConversionUnity.vue'
import ProductFlavors from './ProductFlavors.vue'
import ProductFractionalSale from './ProductFractionalSale'
import ProductItemsGrid from './ProductItemsGrid'
import { swall } from '../../services/sweetAlert'
import ProductSideVariations from './ProductSideVariations'
import ProductPrice from './ProductPrice'

export default {
    name:'ProductModal',
    props: {
        modal_name: {
            required: true
        }
    },
    components: {
        ProductActions,
        LoadingApp,
        CalculaFrete,
        LinkYoutube,
        InterestFreeInstallments,
        Rating,
        ProductVariations,
        ProductOptionsConversionUnity,
        ProductFlavors,
        ProductItemsGrid,
        ProductFractionalSale,
        ProductSideVariations,
        ProductPrice,
        'product-price-page': CProductPricePage,
        'product-title': CProductTitle,
        'product-width': CProductWidth,
        'c-ancora': CAncora,
        'modal-content': CModalContent,
        'c-span': CSpan
    },
    data() {
        return {
            company: this.$root.$children[0].$attrs.company,
            locale_linked_products: this.$root.$children[0].$attrs.company?.products_settings?.locale_linked_products ?? 1,
            show_payment_flags_product_page: this.$root.$children[0].$attrs.company?.products_settings?.show_payment_flags_product_page ?? false,
            payment_flags: this.$root.$children[0].$attrs.company?.settings?.payment_flags ?? [],
            asset: this.$root.$children[0].assets ?? 'assets/',
            currency: Currency,
            isLoading: false,
            mediaDesktop: window.matchMedia("(min-width:600px)").matches,
            windowSize: null,
            image_main_id:null,
            free_shipping_color: this.$root.$children[0].theme?.products?.free_shipping?.color ?? '#223ace',
            keyProductImage: 0,
            item_grid: null,
            variation: null,
        }
    },
    beforeUpdate() {
        this.mediaDesktop = window.matchMedia("(min-width:600px)").matches
        this.media
    },
    validations: {
        variation: {
            required: requiredIf(function () {
                return this.variations.length > 0 && this.locale_linked_products == 2
            })
        },
        item_grid: {
            required: requiredIf(function() {
                return this.showItemsGrid
            })
        }
    },
    methods: {
        ...mapActions("cart", [
            "ActionSetItemCart",
            "ActionSetItemsCart",
            "ActionAddItemsCart"
        ]),
        ...mapActions("products", [
            "ActionSetMinimumQuantity",
            "getAdditionalItems",
            "setAdditionalItems",
            "ActionResetCarouselModal",
            "setQuantity",
            "setResetItemsGrid",
            "setPriceProduct",
            "ActionSetItemByVariation",
            "ActionSetProductPriceToBkpDiscountClosedBox",
            "setMinimumQuantityFractional",
            "setQuantityFractional",
            "setAvailability"
        ]),
        ...mapActions("company", [
            "ActionSetAccessManagement"
        ]),
        selectedVariation(variation) {
            jQuery('.product-single-carousel-quick-view').owlCarousel('destroy');
            setTimeout(() => {
                this.ActionResetCarouselModal('product-single-carousel-quick-view');
            }, 10);
            this.ActionSetProductPriceToBkpDiscountClosedBox(variation?.price_to ? JSON.parse(JSON.stringify(variation.price_to)) : null);
            this.ActionSetItemByVariation(variation ? {...variation} : null);
            this.variation = variation ? {...variation} : null;
            this.keyProductImage++;
            this.ActionSetMinimumQuantity();
        },
        showModalProductCustomization() {
            this.getAdditionalItems(this.item?.id)
                .then(response => {
                    if(!this.additionalItems.length) {
                        this.setAdditionalItems(response.data)
                    }
                }).catch(error => {
                    swall(error?.msg ?? error)
                })
            this.$root.showModalApp("modal_product_customization");
        },
        validateMaximumPurchaseAmountByUser(item) {
            let priceMaxPurchase = Number(this.client?.maximum_purchase_amount)
            let cartTotalAmount = Number(this.itemsCart?.totalAmount)
            let purchasePrice = (item.pro_qtd * Number(this.item.pro_price_site)) + cartTotalAmount

            if(purchasePrice == priceMaxPurchase) {
                return false
            }

            if(cartTotalAmount > priceMaxPurchase || purchasePrice > priceMaxPurchase) {
                let availableQuantity = (priceMaxPurchase - cartTotalAmount).toFixed(2)
                if(availableQuantity > 0) {
                    swall(`Seu limite restante é de ${this.currency.money(availableQuantity)} em compras!`)
                } else {
                    swall("Valor máximo de compra atingido!")
                }
                return true
            }
            return false
        },
        isInvalidItemGrid(item) {
            if(item.pro_qtd > this.item_grid.quantity && !this.itemsCart.list.length && !this.item.sell_out_of_stock) {
                return true
            }

            if(this.itemsCart.list.length && !this.item.sell_out_of_stock) {
                let qtdItemCart = this.itemsCart.list.find(el => el.items_grid_id == item.items_grid_id && el.id == item.pro_id)
                if(qtdItemCart && item.pro_qtd > (this.item_grid.quantity - qtdItemCart.qtd_cart)) {
                    return true
                }
            }
            return false
        },
        validateSupplier() {
            let cartSupplier = this.itemsCart?.list[0]?.supplier_name
            let supplierProduct = this.item?.suppliers[0]?.supplier_name

                if (this.itemsCart.list.length && supplierProduct != cartSupplier)
                {
                    swall("Já existe outro fornecedor adicionado ao carrinho!")
                    return true
                }
            return false
        },
        async addCart(data) {
            let redirect_cart = data.redirect_cart

            if(!this.item) {
                return;
            }
            let item = {
                pro_id: this.item.id,
                pro_qtd: this.quantity,
                type: data.type,
                additionalItems: this.additionalItemsSelected,
                items_grid_id: this.item_grid?.items_grid_id,
                flavors: this.getFlavorsSelected,
                fractional_quantity: this.item.fractional_sale ? this.quantityFractional : null
            }
            if(this.$v.$invalid) {
                this.$v.$touch()
                return
            }
            if (item.items_grid_id && this.isInvalidItemGrid(item)) {
                swall("Quantidade indisponível!")
                return
            }
            if(item.flavors.length < Number(this.minimumAmountOfFlavorsToSelect)) {
                this.isLoading = false
                let message = `
                    Escolha ${
                        Number(this.minimumAmountOfFlavorsToSelect) < Number(this.maximumAmountOfFlavorsToSelect) ?
                        'ao menos' : ''
                    } ${this.minimumAmountOfFlavorsToSelect} ${this.minimumAmountOfFlavorsToSelect > 1 ? 'sabores' : 'sabor'}!
                `
                swall(message, true)
                return
            }
            if(this.atLeastOneAdditionalItemRequired && !(item?.additionalItems?.items?.length > 0)) {
                swall(
                    `Escolha ${this.getValidationSelectOnlyOneAdditionalItem ? '' : 'ao menos '}um item adicional clicando no botão "Personalize seu produto"`,
                    true
                )
                return
            }

            if(this?.item?.quantity_per_box && this.conversionUnitWhenSellingWithClosedBox == 'CX') {
                item.pro_qtd = Number(item.pro_qtd) * Number(this.item.quantity_per_box)
                item.discount_when_selling_with_closed_box = true
            }

            if(this.item.minimum_sale_quantity) {
                if(item.pro_qtd < this.item.minimum_sale_quantity) {
                    swall(`A quantidade mínima é ${this.item.minimum_sale_quantity} ${this.item.pro_sigla_medida}!`)
                    return
                }
            }
            if(this.itemsCart?.list?.length && !this.item.sell_out_of_stock) {
                let qtdItemCart = this.itemsCart.list.find(el => el.id == item.pro_id)
                if(qtdItemCart && +item.pro_qtd > (+this.item.pro_stock_site - qtdItemCart.qtd_cart)) {
                    swall("Quantidade indisponível!")
                    return
                }
            }

            if(this.client?.maximum_purchase_amount && this.client.maximum_purchase_amount > 0 && this.validateMaximumPurchaseAmountByUser(item)) {
                return
            }

            if (this.validateSupplier()) {
                return
            }
            this.isLoading = true
            // localStorage.setItem('reset_product_modal', 'false')

            if (this.item.is_linked_products && this.variations?.length) {
                let formData = new FormData()

                let arr = [{
                    ...this.item,
                    father_product: this.variations.find(v => v.father_product_id)?.father_product_id ?? null,
                    is_product_group: false,
                    pro_id: this.item.id,
                    pro_qtd: this.quantity,
                }]

                formData.append('itemsCart', JSON.stringify(arr))
                await this.ActionAddItemsCart(formData)
                    .then(async (resp) => {
                        this.isLoading = false
                        let {data} = resp
                        this.ActionSetItemsCart(data)
                        if(this.facebookPixel?.settings?.AddToCart == true) {
                            fbq('track', 'AddToCart')
                        }
                        if(this.googleAds?.id != null) {
                            const findItem = data.list.find(product => product.id == item.pro_id)
                            gtag('event', 'add_to_cart', {
                                'pageTitle': this.company.nome_fantasia,
                                'pageCategory': 'Produto',
                                'ecommerce' :{
                                    'currency': 'BRL',
                                    'value': ((findItem.price_to ?? findItem.pro_price_site) * Number(item.pro_qtd)).toFixed(2),
                                    'products' : [{
                                        'id' : findItem.api_cod_original,
                                        'name': findItem.pro_name_site,
                                        'discount' : findItem.percentage_discount,
                                        'quantity' : item.pro_qtd,
                                        'price': findItem.pro_price_site.toFixed(2),
                                        'variant': findItem.items_grid_abbreviaton ?? (findItem.grid_group_column_value ?? '' + findItem.grid_group_row_value ?? '')
                                    }],
                                }
                            });
                        }
                        if(redirect_cart == true) {
                            window.location.href = this.openCartPage == true ? this.$baseUrl + 'cart' : this.$baseUrl + 'checkout'
                            return
                        }
                        if(this.item_grid) {
                            this.item_grid = null
                        }
                        this.setResetItemsGrid(true)
                        this.$root.closeModalApp(this.modal_name)
                        swall('Produto adicionado ao carrinho com sucesso!', false, "check", "success")
                    })
                    .catch((error) => {
                        this.isLoading = false
                        swall(error?.msg ?? error?.message ?? error)
                    })
                return;
            }

            await this.ActionSetItemCart(item)
            .then(async (resp) => {
                this.isLoading = false
                let {data} = resp
                this.ActionSetItemsCart(data)
                if(this.facebookPixel?.settings?.AddToCart == true) {
                    await fbq('track', 'AddToCart', {content_type: 'product', contents: {id: item.pro_id, quantity: Number(item.pro_qtd)}})
                }
                if(this.googleAds?.id != null) {
                    const findItem = resp.data.list.find(product => product.id == item.pro_id &&
                    (!item.items_grid_id || product.items_grid_id === item.items_grid_id))
                    gtag('event', 'add_to_cart', {
                        'pageTitle': this.company.nome_fantasia,
                        'pageCategory': 'Produto',
                        'ecommerce' :{
                            'currency': 'BRL',
                            'value': ((findItem.price_to ?? findItem.pro_price_site) * Number(item.pro_qtd)).toFixed(2),
                            'products' : [{
                                'id' : findItem.api_cod_original,
                                'name': findItem.pro_name_site,
                                'discount' : findItem.percentage_discount,
                                'quantity' : Number(item.pro_qtd),
                                'price': (findItem.price_to ?? findItem.pro_price_site).toFixed(2),
                                'variant': findItem.items_grid_abbreviaton ?? (findItem.grid_group_column_value ?? '' + findItem.grid_group_row_value ?? '')
                            }],
                        }
                    });
                }
                if(redirect_cart == true) {
                    window.location.href = this.openCartPage == true ? this.$baseUrl + 'cart' : this.$baseUrl + 'checkout'
                    return
                }
                if(this.item_grid) {
                    this.item_grid = null
                }
                this.setResetItemsGrid(true)
                this.$root.closeModalApp(this.modal_name)
                swall('Produto adicionado ao carrinho com sucesso!', false, "check", "success")
            })
            .catch((error) => {
                this.isLoading = false
                swall(error?.msg ?? error)
            })
        },
        initCarouselBootstrap() {
            setTimeout(() => {
                try {
                    let el = this.item.images.find(el => el.main && el.is_table_size == false)
                    this.image_main_id = el.id
                    $('#carouselModalProductsBootstrap .carousel-item').each(function() {
                        $(this).removeClass('active')
                    })
                    let firstImage = document.getElementById('carousel-item-'+el.id)
                    firstImage.classList.add('active')
                } catch (error) {
                    this.initCarouselBootstrap()
                }
            }, 200)
        },
        controlsIndicatorsSlider(id) {
            let imgSlider = document.getElementById('carousel-item-'+id)
            $('#carouselModalProductsBootstrap .carousel-item').each(function() {
                $(this).removeClass('active')
            })
            imgSlider.classList.add('active')
        },
        setItemDiscountWhenSellingWithClosedBox(val) {
            if(this?.item?.quantity_per_box && val == 'CX') {
                let itemPercentage = this.productSettings?.discount_percentage_when_closed_box_sale &&
                    this.productSettings.discount_percentage_when_closed_box_sale != 0 ?
                    parseFloat(this.productSettings.discount_percentage_when_closed_box_sale) : null

                let percentage = itemPercentage ?? this.geralDiscountPercentageWhenClosedBoxSale
                if(!percentage || !this?.item?.is_applicable_discount_when_closed_box) {
                    return
                }
                let price = this.item.price_to ?? this.item.pro_price_site
                return this.item.price_to = price - price * (percentage / 100)
            }
            this.item.price_to = this.product_price_to_bkp_discount_closed_box
        },
        getPriceFlavor(price_flavor) {
            return this.item.price_to ? price_flavor - (price_flavor * (this.item.percentage_discount / 100)) : price_flavor
        },
        handleSelectItemGrid(itemGrid) {
            this.item_grid = itemGrid
            let data = {
                grid_price: itemGrid?.grid_price_site ?? this.product_pro_price_site_bkp_discount_closed_box
            }
            this.setPriceProduct(data)
        },
        async resetProduct() {
            this.keyProductImage++;
            if (this.item.fractional_sale) {
                await this.setMinimumQuantityFractional(this.item);
                this.setQuantityFractional(this.minimumQuantityFractional);
            }
            this.$v.$reset();
        }
    },
    updated(){
        if(!this.item) {
            return;
        }
        // let reset_product_modal = JSON.parse(localStorage.getItem('reset_product_modal'))
        // if(reset_product_modal == true){
        //     localStorage.setItem('reset_product_modal','false')
        // }
        const data = {
            product: this.item.id,
            company_id: this.company.id
        }
        this.ActionSetAccessManagement(data)
    },
    computed: {
        ...mapState("products", [
            "item",
            "conversionUnitWhenSellingWithClosedBox",
            "product_price_to_bkp_discount_closed_box",
            "product_pro_price_site_bkp_discount_closed_box",
            "additionalItemsSelected",
            "additionalItems",
            "quantity",
            "minimumQuantity",
            "flavors",
            "variations",
            "reset",
            "quantityFractional",
            "minimumQuantityFractional"
        ]),
        ...mapState('company', [
            'facebookPixel',
            "googleAds"
        ]),
        ...mapState("cart", [
            "itemsCart"
        ]),
        ...mapGetters("products", [
            "getValidationSelectOnlyOneAdditionalItem",
            "getFlavorsSelected",
            "minimumAmountOfFlavorsToSelect",
            "maximumAmountOfFlavorsToSelect",
            "showItemsGrid"
        ]),
        ...mapState("clients", ["client"]),
        ...mapGetters("company", [
            "showRatings",
            "getShowUnitOfMeasureInProductPrice",
            "showCodeOriginalBesideDescription",
            "showIpi"
        ]),
        showCodeOriginal() {
            return (
                this.showCodeOriginalBesideDescription &&
                this.item.api_cod_original
            );
        },
        product_name_site() {
             this.setAvailability(this.item.availability)
            let textTransform = this.$root.$children[0].theme?.products?.product_page?.text_transform_title ?? ''

            return textTransform == 'uppercase' ? this.item?.pro_name_site?.toUpperCase() :
                textTransform == 'lowercase' ? this.item?.pro_name_site?.toLowerCase() :
                textTransform == 'initial' ? (this.item?.pro_name_site[0]?.toUpperCase() + this.item?.pro_name_site?.substr(1)?.toLowerCase()) :
                textTransform == 'capitalize' ? (this.item?.pro_name_site?.toLowerCase()?.replace(/(?:^|\s)\S/g, function(a) { return a?.toUpperCase(); })) : this.item?.pro_name_site
        },
        geralDiscountPercentageWhenClosedBoxSale() {
            return this.$root.$children[0].$attrs.company?.products_settings?.discount_percentage_when_closed_box_sale &&
                this.$root.$children[0].$attrs.company.products_settings.discount_percentage_when_closed_box_sale != 0 ?
                parseFloat(this.$root.$children[0].$attrs.company.products_settings.discount_percentage_when_closed_box_sale) : null
        },
        media() {
            window.onresize = () => {
                this.windowSize = window.innerWidth
                if(window.innerWidth < 600) {
                    this.mediaDesktop = false
                } else {
                    this.mediaDesktop = true
                }
            }
        },
        hasControlsCarousel() {
            let lengthImgsTableSize = this.item.images.filter(el => el.is_table_size == true)
            let lengthImages = this.item.images.length - lengthImgsTableSize.length
            return lengthImages > 1
        },
        hidePrice() {
            let hide = this.company?.settings?.hide_price_not_logged_user ?? false
            return ( hide === false ) ? false : ( hide === true && this.isLogged === false ? true : false )
        },
        isLogged() {
            return this.$root.$children[0].$attrs.logged
        },
        ipi_variation() {
            return ((this.item?.linked_products ? this.item.linked_products.find(el => el.ipi_percentage) : null) ? true : false)
        },
        validateProductGroup() {
            return (this.activateSaleProductGroups && this.isProductGroup)
        },
        isProductGroup() {
            return this.productSettings?.is_product_group ?? false
        },
        productSettings(){
            if(this.item?.settings) {
                return JSON.parse(this.item.settings)
            }
            return null
        },
        activateSaleProductGroups() {
            return this.$root.$children[0].$attrs.company?.settings?.activate_sale_product_groups ?? false
        },
        isProductCustomization() {
            return this.productSettings?.is_product_customization ?? false
        },
        activateProductCustomization() {
            return this.$root.$children[0].$attrs.company?.settings?.activate_product_customization ?? false
        },
        atLeastOneAdditionalItemRequired() {
            return this.productSettings?.at_least_one_additional_item_required ?? false
        },
        isBudgetLayout() {
            return this.$root.$children[0].theme?.is_budget_layout ?? false
        },
        maxHeightImage() {
            return this.$root.$children[0].theme?.products?.product_page?.maxheight_image ?? 'none'
        },
        openCartPage() {
            return this.$root.$children[0].theme?.cart.open_cart_page ?? true
        }
    },
    watch: {
        mediaDesktop() {
            jQuery('.product-single-carousel-quick-view').owlCarousel('destroy')
            setTimeout(() => {
                this.ActionResetCarouselModal('product-single-carousel-quick-view')
            }, 10);
            this.keyProductImage++
        },
        conversionUnitWhenSellingWithClosedBox(val) {
            if(this.item && !window.location.href.includes('/product/')) {
                this.ActionSetMinimumQuantity()
                this.setItemDiscountWhenSellingWithClosedBox(val)
            }
        },
        reset(reset) {
            if (reset) {
                this.resetProduct();
            }
        }
    }
}
</script>

<style scoped>
.carousel-control-next,
.carousel-control-prev {
    filter: invert(100%);
}
.additional-item-price-box {
    display: block;
}
.additional-item-price-box::after {
    content: "+";
}
.additional-item-price-box:last-child::after {
    content: "";
}
</style>
